import {
  useSearchParams,
} from 'react-router-dom'

export function TravelCardSetupResultPage() {
  const [searchParams] = useSearchParams()
  const canceled = searchParams.get('canceled') === 'true'

  return (
    <main className="min-h-screen bg-[#f7f5f2] px-6 py-16 text-[#212121]">
      <div className="mx-auto max-w-lg rounded-2xl border border-black/10 bg-white p-8 shadow-sm">
        <div className="mb-5 text-sm font-semibold uppercase tracking-[0.18em] text-[#706b66]">
          Catch travel
        </div>
        <h1 className="mb-4 font-display text-4xl">
          {canceled ? 'Card setup canceled' : 'Travel card saved'}
        </h1>
        <p className="text-base leading-7 text-[#56514d]">
          {canceled
            ? 'No card details were changed. You can reopen the secure link from your email when you are ready.'
            : 'Your travel payment method is ready. Catch can now use it for travel bookings you explicitly approve.'}
        </p>
        <p className="mt-6 text-sm text-[#706b66]">
          You can close this tab.
        </p>
      </div>
    </main>
  )
}
